import { IAnalyticsEventButton, IAnalyticsEventButtonArgument } from './types';

export const buttonClicked = (
  button: IAnalyticsEventButtonArgument,
): IAnalyticsEventButton => {
  return {
    eventName: 'Button Clicked',
    object_type: button.context,
    object_name: button.action,
  };
};
